import { Toast } from "primereact/toast";
import { useRef } from "react";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

export const LoginHistory = (permissions: IPermissionProps) => {
    const toast = useRef<any>(null);

    return (
        <>
            {/* { permissions.is_View && <Table permissions={permissions} toast={toast}></Table> } */}
            { permissions.is_View && <Table permissions={permissions} toast={toast}></Table>}
            <Toast ref={toast} />
        </>
    );
}
